import { ESdChangeReason, IAiAgentModel, IAiAgentTemplate, IAiModel, IAiTemplate } from "@kuika/kuika-cl-model";
import * as React from "react";
import {
  KuikaTemplateCardGrid,
  KuikaTemplateCardSkeleton
} from "../../../ui-kit/kuika-template-card/kuika-template-card";
import AIActionTemplate from "./ai-action-template";

export interface IAIActionTemplatesState {}

export interface IAIActionTemplatesProps {
  aiTemplates: IAiTemplate[] | IAiAgentTemplate[];
  aiModels: IAiModel[] | IAiAgentModel[];
  selectedTemplateId?: string;
  setTemplateSelected: (modelId: string, name: string, template?: IAiTemplate | IAiAgentTemplate) => void;
  isTemplatesLoading: boolean;
  isEditing?: boolean;
  onEdit?: (templateId: string) => void;
  onCreateTemplate?: (modelId: string, name: string, template: any) => void;
}

class AIActionTemplates extends React.PureComponent<IAIActionTemplatesProps, IAIActionTemplatesState> {
  constructor(props: IAIActionTemplatesProps) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <KuikaTemplateCardGrid>
        {/* Shimmering cards in the real cards' proportions, so the swap does not
            jump — a dimmed empty grid said nothing about what was coming. */}
        {this.props.isTemplatesLoading ? (
          <KuikaTemplateCardSkeleton />
        ) : (
          this.props.aiTemplates?.map((model: IAiTemplate | IAiAgentTemplate) => (
            <AIActionTemplate
              key={model.id}
              model={model}
              aiModels={this.props.aiModels}
              selectedTemplateId={this.props.selectedTemplateId}
              setTemplateSelected={this.props.setTemplateSelected}
              onEdit={this.props.onEdit}
              onCreateTemplate={this.props.onCreateTemplate}
            />
          ))
        )}
      </KuikaTemplateCardGrid>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    return false;
  };
}

export default AIActionTemplates;
